import React from "react";

const NewsFull = ({ item, onBack }) => {
  return (
    <div className="fixed inset-0 bg-white text-black z-50 overflow-y-auto animate-fadeIn">
      <div className="max-w-2xl mx-auto p-4 pb-20"> {/* добавлен нижний отступ */}
        <button
          onClick={onBack}
          className="mb-4 text-blue-600 hover:text-blue-800 font-medium flex items-center gap-2"
        >
          ← Назад
        </button>

        {item.image && (
          <figure className="w-full h-[220px] mb-4">
            <img
              src={item.image}
              alt={item.title}
              className="object-cover w-full h-full rounded-xl"
            />
          </figure>
        )}

        <span className="block text-sm text-gray-500 mb-2">
          {new Date(item.date).toLocaleDateString("ru-RU")}
        </span>

        <h1 className="text-2xl font-semibold mb-4 text-black">
          {item.title}
        </h1>

        <div
          className="prose max-w-none text-gray-800 prose-headings:text-black prose-p:text-gray-800 prose-strong:text-black"
          dangerouslySetInnerHTML={{ __html: item.fullText }}
        />
      </div>
    </div>
  );
};

export default NewsFull;
